import { z } from "zod";

const typesafeErrorTypeValues = ["MISSING_API_KEY"] as const;

const typesafeErrorTypeSchema = z.enum(typesafeErrorTypeValues);
const TypesafeErrorType = typesafeErrorTypeSchema.enum;
type TypesafeErrorType = z.infer<typeof typesafeErrorTypeSchema>;

interface ErrorDetails {
  sentryDescription: string;
}

export type TypesafeErrors = {
  errorType: typeof TypesafeErrorType.MISSING_API_KEY;
  data: Record<string, never>;
};

export const typesafeErrorDetails: Record<TypesafeErrorType, ErrorDetails> = {
  [TypesafeErrorType.MISSING_API_KEY]: {
    sentryDescription: "TYPESAFE_API_KEY is not configured in this environment",
  },
};
